<template>
    <div>

    </div>
</template>

<script>
    import * as API from "../api";
    import {mapActions} from "vuex";
    import draggable from "vuedraggable"
    import $ from 'jquery';
    // import Video from "../../../video/index";
    export default {
        name: 'TaskDetail',
        components:{
            // Video,
            draggable
        },
        props:{

            pvdata:{
                type:Array
            },
            title:{
                type:String
            }

        },
        data(){
            return{
                ptlist:[],
                consumername:[],
                rules: {
                    // name: [
                    //     { required: true, message: '请输入模板名称', trigger: 'blur' },
                    //
                    // ],
                    // jsonData: [
                    //     { required: true, message: '请输入录入内容模板', trigger: 'blur' }
                    // ],


                }
            }
        },


        watch:{
        },
        mounted(){
            let add=[]
            if(this.title=='图片'){
                this.pvdata.forEach(item=>{

                    add.push(item.path)

                })
                this.ptlist=add
            }else{

            }

           // console.log(this.ptlist)
        },
        methods:{
            ...mapActions(["getCurrentMenuId"]),

            close(){
                this.$emit('de')
            },




        }
    }
</script>
<style lang="scss" scoped>
    /deep/{
        .aaa{
            display: flex;
            align-items: center;
            margin-right: 5px;
        }
        .bbb{
            display: flex;
            align-items: center;
        }
        .aaa .el-radio__label{
            display: inline-block;
            width: 92px !important;
        }
        .aaa .el-input__inner{
            width: 90px !important;
        }
        .el-checkbox__label{
            padding-left: 5px !important;
        }

        .checkbox .el-input--mini{
            width:167px ;
        }
        .el-radio:last-child{
            margin-right: 10px !important;
        }
        .el-checkbox{
            /*width: 189px !important;*/
            width: 100%;
        }
        .el-checkbox__label{
            display: inline-grid;
            width: 100%;

            white-space: pre-line;
            word-wrap:break-word ;
        }
        .el-cascader-node>.el-radio, .el-radio:last-child{
            margin-right: 25px !important;
        }
        /*.el-radio{*/
        /*margin-right: 0 !important;*/
        /*}*/
        .draggable{
            display: flex;
            padding: 3px;
            align-items: center;
        }
        .checkdra .el-checkbox__input{
            margin-left: 4px !important;
        }
        .taoinput .el-input__inner{
            width: 120px !important;
            display: inline-block !important;
        }
        .checkbox .el-checkbox__label{
            color: black;
        }
        .checkdra{
            color: black;

        }
        .el-radio__label{
            color: black;

        }
        .iptinput .el-input__inner{
            width: 140px !important;
            display: inline-block !important;
        }
        .checkdra .el-input__inner{
            width: 120px !important;
            display: inline-block !important;
        }
        .el-checkbox__label{
            padding-left: 10px !important;
        }
        .checkbox .el-input__inner{
            width: 157px !important;
        }
        .radio .el-input__inner{
            width: 70px !important;
            display: inline-block !important;
        }
        .radiodra .el-input__inner{
            width: 90px !important;
            display: inline-block !important;
        }
        .drag{
            color: black;
        }
        .radiodra{
            color: black;
        }
        .radio .el-input{
            width: inherit !important;
        }
        .radio .el-radio{
            margin-right: 15px;
        }
        .taoradio .el-radio{
            margin-right: 15px;

        }
        .drag .el-input__inner{
            /*color: black !important;*/
            width: 90px !important;
            display: inline-block !important;
        }
        .draggable .el-input__inner{

            width: 150px !important;
            display: inline-block !important;
        }
        .lable-width .el-form-item__content{
            margin-left: 0 !important;
        }
        .el-textarea__inner{
            height: 100px !important;
            color: #000000 !important;
            /*font-weight: 600 !important;*/
            font-size: inherit !important;
        }
        .el-form-item__error{
            left: 50% !important;
        }
    }
    .lable-width{
        text-align: center;
    }
    .slable-width{

    }
    /deep/.dcsiii .el-input__inner{
        width: 90px !important;
    }
    /deep/.dcsiii .el-input{
        width: inherit;
    }
    .dialog-footer{
        display: flex;
        justify-content: center;
        align-items: center;
        /*text-align: center;*/
        margin-top: 12px;
    }
    .input-width{
        /*text-align: center;*/
        width: 18.571rem;
    }
    .sinput-width{
        width: 150px;
        margin-left: 28px;
    }
    /deep/.json .el-textarea__inner{
        height: 180px !important;
    }
    /deep/.describe .el-textarea__inner{
        height: 80px !important;

    }
    /deep/.ggg .el-input{
        width: inherit;
    }
    .lv{
        color: #3cb44b;

    }
    .ju{
        color: #f08c00;
    }
    .hei{
        color: #808080;

    }
    /deep/.describe .el-form-item__content{
        margin-left: 0px !important;

    }
</style>